<template>
  <v-container background fluid pa-3 v-scroll="onScrollFunction" class="contain_width">
    <div id="search_box" class="searching_box">
      <v-text-field
        v-show="show_search"
        name="search_item"
        v-model="Search_data"
        @input="searchProcess()"
        label="ค้นหา..."
        style="margin-top: 7px; color: #fff"
        flat
        color="white"
        class="search_text"
        append-icon
        clearable
      />
    </div>
    <filter-component :json_data="form_filter_data" v-on:set="onCloseFormDialog" />

    <v-btn slot="activator" icon @click="searchClick()" class="btn_show_search">
      <v-icon :size="16">fa-search</v-icon>
    </v-btn>
    <v-btn slot="activator" icon @click="showFilter(true)" class="btn_show_filter">
      <v-icon :size="16">fa-filter</v-icon>
    </v-btn>

    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page_flex">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="Search_data"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap hidden-xs-only>
      <v-flex xs12 sm12 class="search_in_page">
        <v-text-field
          solo
          label="ค้นหา..."
          v-model="Search_data"
          @input="searchProcess()"
          append-icon="search"
          style="margin-bottom: 0px"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <!-- Create Button -->
      <v-flex md12 sm12 xs12 v-if="permission_edit == true || admin == 'true'">
        <!-- <v-tooltip top> -->
        <v-btn
          color="primary"
          dark
          fixed
          bottom
          right
          fab
          @click="onHandleDialog(true, 'create', null)"
        >
          <v-icon>fa-plus</v-icon>
        </v-btn>
        <!-- <span>{{$t('create')}}</span>
        </v-tooltip> -->
      </v-flex>
      <v-layout
        row
        align-center
        text-xs-center
        style="margin-top: 5rem; margin-bottom: 15rem"
        v-if="table_data.length == 0 && !showLoading"
      >
        <v-flex
          xs12
          md4
          offset-md4
          lg2
          offset-lg5
          class="adddoc-hover"
          style="cursor: pointer"
          v-if="permission_edit == true || admin == 'true'"
        >
          <v-tooltip top>
            <template slot="activator">
              <div
                @click="onHandleDialog(true, 'create', null)"
                style="padding-top: 40px; padding-bottom: 40px"
              >
                <v-icon style="font-size: 80px" color="blue">fa fa-plus</v-icon>
                <h3 class="headline mb-0" style="color: #2195f3">
                  {{ $t("AddIncomeExpenses") }}
                </h3>
              </div>
            </template>
            <span>{{ $t("ClickFor") }} {{ $t("AddCheckInOut") }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
      <!-- List -->
      <v-flex md12 sm12 xs12>
        <v-layout row wrap v-if="!showLoading">
          <v-flex
            lg4
            md6
            sm6
            xs12
            pa-1
            v-for="(item, index) in table_data"
            :key="index"
            @click="
              '';

            "
          >
            <v-card
              class="coco-box-shadow"
              v-bind:style="[
                item.trans_flag == 0
                  ? { 'border-left': '5px solid #408550', 'border-radius': '5px' }
                  : { 'border-left': '5px solid #E3624E', 'border-radius': '5px' },
              ]"
            >
              <v-layout row wrap class="coco-list-layout" pa-3>
                <v-flex lg2 md3 sm3 xs2 text-xs-center>
                  <v-avatar :size="64">
                    <v-avatar v-show="item.trans_flag == 0" :size="64" color="green">
                      <span class="white--text">{{ $t("income") }}</span>
                    </v-avatar>
                    <v-avatar v-show="item.trans_flag == 1" :size="64" color="red">
                      <span class="white--text">{{ $t("expensed") }}</span>
                    </v-avatar>
                    <!-- <Empimage
                      v-if="item.emp_images != '' && item.emp_images != undefined  && item.emp_images != null"
                      :json_data="item.emp_images"
                    />-->
                  </v-avatar>
                </v-flex>
                <v-flex lg7 md7 sm7 xs8>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <!--<span
                        class="coco-list-label-text"
                      >{{isEmpty(item.emp_code)? item.emp_code : 'emp_code'}}:</span>-->
                      <v-layout row wrap>
                        <v-flex lg12 md12 sm12 xs12>
                          <span>{{ item.firstName }} {{ item.lastName }}</span>
                          <span
                            v-if="item.nick_name != '' && item.nick_name != null"
                            style="margin-right: 15px"
                            v-html="
                              ' (<span style=color:#166BFF;>' +
                              item.nick_name +
                              '</span>)'
                            "
                          />
                        </v-flex>
                        <v-flex lg12 md12 sm12 xs12>
                          <span class="coco-list-label-icon" style="margin-right: 15px">
                            <v-icon class="coco-label-icon">calendar_today</v-icon>
                            <span>{{ selectedformatDates(item.add_date) }}</span>
                          </span>
                        </v-flex>
                        <v-flex lg12 md12 sm12 xs12>
                          <span class="coco-list-label-icon" style="margin-right: 15px">
                            <v-icon class="coco-label-icon">monetization_on</v-icon>
                            <span v-show="currencySymbols == '0'">{{
                              symbolStyles + " " + formatNumber(item.amount, 2, true)
                            }}</span>
                            <span v-show="currencySymbols == '1'">{{
                              formatNumber(item.amount, 2, true) + " " + symbolStyles
                            }}</span>
                          </span>
                        </v-flex>
                        <v-flex lg12 md12 sm12 xs12>
                          <span class="coco-list-label-icon">
                            <v-icon class="coco-label-icon">info</v-icon>
                            <span>{{ isEmpty(item.name) ? item.name : "-" }}</span>
                          </span>
                        </v-flex>
                      </v-layout>

                      <!--<b v-show="item.trans_flag == 0" style="color: #689F38;">รายได้</b>
                      <b v-show="item.trans_flag == 1" style="color: #E53935;">ค่าใช้จ่าย</b>-->
                    </v-flex>
                    <v-flex xs12 class="hidden-xs-only">
                      <!-- <span class="coco-list-label-text hidden-sm-only">
                        {{$t('branch')}}:
                        <span>
                          {{isEmpty(item.branch)? item.branch
                          : 'branch'}}
                        </span>
                      </span>
                      <span class="coco-list-label-text hidden-sm-only">
                        {{$t('Department')}}:
                        <span>
                          {{isEmpty(item.department_name) ?
                          item.department_name : 'department_name'}}
                        </span>
                      </span>
                      <span class="coco-list-label-text hidden-sm-only">
                        {{$t('Position')}}:
                        <span>
                          {{isEmpty(item.position) ?
                          item.position : 'position'}}
                        </span>
                      </span>-->
                    </v-flex>
                    <!--   <v-flex xs12 class="hidden-sm-and-up">
                      <span class="coco-list-label-icon">
                        <v-icon style="padding-left: 0px;">access_time</v-icon>
                        <span>{{formatDate(item.add_date, formatDates)}}</span>
                      </span>
                      <span class="coco-list-label-icon">
                        <v-icon>monetization_on</v-icon>
                        <span
                          v-show="currencySymbols == '0'"
                        >{{symbolStyles + ' ' + formatNumber(item.amount, 2, true)}}</span>
                        <span
                          v-show="currencySymbols == '1'"
                        >{{formatNumber(item.amount, 2, true) + ' ' + symbolStyles}}</span>
                      </span>
                    </v-flex>
                    <v-flex xs12 class="hidden-sm-and-up">
                      <span class="coco-list-label-icon">
                        <v-icon style="padding-left: 0px;">info</v-icon>
                        <span>{{isEmpty(item.name) ? item.name : '-'}}</span>
                      </span>
                    </v-flex>-->
                  </v-layout>
                </v-flex>
                <v-flex lg2 md1 sm1 xs2>
                  <v-layout row wrap>
                    <v-flex lg2 md2 sm2 xs2 text-xs-right style="margin: auto">
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-menu offset-y>
                          <template slot="activator">
                            <v-btn icon style="color: rgba(0, 0, 0, 0.54)">
                              <v-icon>fas fa-ellipsis-v</v-icon>
                            </v-btn>
                          </template>
                          <v-card class="pa-0" max-width="344">
                            <v-card-title
                              class="setbox"
                              v-if="permission_edit == true || admin == 'true'"
                            >
                              <v-btn
                                color="orange"
                                slot="activator"
                                flat
                                @click="onHandleDialog(true, 'update', item)"
                              >
                                <v-icon>edit</v-icon>
                                <span> {{ $t("edit") }}</span>
                              </v-btn>
                            </v-card-title>
                            <v-card-title
                              class="setbox"
                              v-if="permission_edit == true || admin == 'true'"
                            >
                              <v-btn color="red" flat @click="deleteItem(item)">
                                <v-icon>delete</v-icon>
                                <span> {{ $t("delete") }}</span>
                              </v-btn>
                            </v-card-title>
                          </v-card>
                        </v-menu>
                      </v-card-actions>
                    </v-flex>
                    <!-- <v-flex md12 sm12 xs12 text-xs-center>
                      <v-layout row wrap>
                        <v-flex offset-lg5 offset-md3 lg3 md4 xs6 v-if="check_permission == true || admin == 'true'"> 
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="warning"
                              icon
                              flat
                              @click="onHandleDialog(true,'update',item)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <span>{{$t('edit')}}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex lg3 md4 xs6 v-if="check_permission == true || admin == 'true'">
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="error"
                              icon
                              flat
                              @click="deleteItem(item)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                            <span>{{$t('delete')}}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex> -->
                  </v-layout>
                </v-flex>
                <!-- <v-flex xs12 class="hidden-sm-and-up">
                  <v-layout row wrap>
                    <v-flex md12 sm12 xs12 text-xs-center>
                      <v-layout row wrap>
                        <v-flex offset-xs8 xs2 v-if="check_permission == true || admin == 'true'">
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="warning"
                              icon
                              flat
                              @click="onHandleDialog(true,'update',item)"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <span>{{$t('edit')}}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex xs2 v-if="check_permission == true || admin == 'true'">
                          <v-tooltip bottom>
                            <v-btn
                              slot="activator"
                              color="error"
                              icon
                              flat
                              @click="deleteItem(item)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                            <span>{{$t('delete')}}</span>
                          </v-tooltip>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex> -->
                <!-- <v-flex
                  xs12
                  offset-md1
                  offset-sm2
                  class="coco-list-divider"
                >
                  <v-divider />
                </v-flex> -->
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- pagination -->
      <v-layout row wrap my-2>
        <v-flex xs12>
          <div class="show_pagination_fixed">
            <v-pagination
              fixed
              v-model="pageActive"
              :length="totalPages"
              :total-visible="7"
              circle
              @input="getExpensesList('List')"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
      <!-- Delete Dialog -->
      <v-flex md12 sm12 xs12>
        <delete-dialog
          :json_data="delete_dialog_data"
          v-on:close-dialog="onCloseDeleteDialog"
          v-on:delete-item="onDelete"
        />
      </v-flex>
      <!-- FormDialog -->
      <v-flex md12 sm12 xs12>
        <frm-dialog :json_data="form_dialog_data" v-on:close-dialog="onCloseFormDialog" />
      </v-flex>
      <!-- Snackbar -->
      <v-snackbar
        v-model="snack_model.status"
        :timeout="3500"
        :top="'top'"
        :color="snack_model.type"
      >
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import DocumentService from "@/services/DocumentService";
import FrmDialog from "./FormDialog.vue";
import Empimage from "../../components/getempimage.vue";
import DeleteDialog from "../../components/master/dialogs/DeleteDialog";
import Utils from "@/utils/";
import $ from "jquery";
import FilterComponent from "./Filter";
import UserService from "@/services/UserService";
export default {
  data: () => ({
    Search_data: "",
    show_search: false,
    form_dialog_data: {
      status: false,
      save_type: String,
      data: Object,
    },
    delete_dialog_data: {
      status: false,
    },
    form_filter_data: {
      status: false,
    },
    snack_model: {
      status: "",
      msg: "",
      type: "",
    },
    table_data: [],
    pageActive: 1,
    totalPages: 0,
    processing: false,
    canLoadMore: true,
    timeout: null,
    permission_edit: false,
    permission_view: false,
    admin: false,
    empCode: localStorage._empcode,
    permission: [],
  }),
  created: async function () {
    await UserService.getpermissionByusercode(this.empCode)
      .then((res) => {
        this.permission = res.data.permission;
        console.log(res);
      })
      .catch((err) => {});
    await this.checkpermission("IncomeList");
    this.admin = localStorage._is_admin;
    console.log(this.check_permission);
    this.commitSetToolbar({
      patternTool: "0",
    });
    this.getExpensesList("Form");
    this.getEmployee("refesh");
    // this.$store.watch(
    //   state => {
    //     state.filter.SelectBranch;
    //     state.filter.SelectDepartment;
    //     state.filter.SelectPosition;
    //     state.filter.FromDate;
    //     state.filter.ToDate;
    //   },
    //   () => {
    //     this.pageActive = 1;
    //     this.table_data = [];
    //     this.canLoadMore = true;
    //     this.getExpensesList("Filter");
    //   },
    //   {
    //     deep: true
    //   }
    // );
  },
  destroyed: function () {
    this.commitToggleAlertDialog({
      status: false,
      message: Object,
    });
  },
  components: {
    FrmDialog,
    Empimage,
    DeleteDialog,
    FilterComponent,
  },
  computed: {
    ...mapState("filter", [
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "SearchData",
      "FromDate",
      "ToDate",
    ]),
    ...mapState("app", ["showLoading", "formatDates", "symbolStyles", "currencySymbols"]),
    ...mapState("filter", ["Employee_List"]),
    ...mapState("permissionmenu", ["permission_List"]),
  },
  methods: {
    ...mapMutations("filter", ["setShowFilter"]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapActions("alert", ["commitToggleAlertDialog"]),
    ...mapActions("filter", ["getEmployee"]),
    goto(path) {
      this.$router.push("/" + path);
    },
    add() {
      this.goto("ImportFile/ImportFileExpensed");
    },
    checkpermission(page) {
      let checkEdit = false;
      let checkView = false;
      if (this.permission.length != 0) {
        this.permission.forEach((element) => {
          if (page == element.module_name) {
            checkEdit = element.edit;
            checkView = element.reads;
          }
        });
      } else {
        checkEdit = false;
        checkView = false;
      }
      this.permission_edit = checkEdit;
      this.permission_view = checkView;
    },
    searchProcess() {
      var v = this;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        v.getExpensesList();
      }, 1500);
    },
    searchClick() {
      if (this.show_search) {
        this.show_search = false;
        $("#pagetitleshow").removeClass("showtitlepage");
      } else {
        this.show_search = true;
        $("#pagetitleshow").addClass("showtitlepage");
      }
    },
    onCloseFormDialog() {
      this.form_dialog_data.status = false;
      setTimeout(() => {
        this.getExpensesList("Form");
      }, 500);
    },
    onCloseDialog() {
      this.pageActive = 1;
      this.table_data = [];
      this.form_dialog_data.status = false;
      this.getExpensesList();
    },
    onCloseDeleteDialog() {
      this.delete_dialog_data.status = false;
    },
    onHandleDialog(status, save_type, data) {
      this.form_dialog_data = {
        status: status,
        save_type: save_type,
        data: data,
      };
    },
    showFilter(status) {
      this.form_filter_data = {
        status: status,
        data: 1,
      };
    },
    selectedformatDates(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("/");
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    formatNumber(value, digit, hasComma) {
      return Utils.formatNumber(value, digit, hasComma);
    },
    formatDate(newDate, format_type) {
      return Utils.formatDate(newDate, format_type);
    },
    onScrollFunction(e) {
      let win_scroll_top = e.target.defaultView.pageYOffset;
      let win_height = window.innerHeight;
      let doc_height = document.body.scrollHeight;

      //console.log("win_scroll_top " + win_scroll_top);
      let width = $(".contain_width").width();
      //console.log("width " + width);
      if (win_scroll_top > 100) {
        $(".search_in_page").show();
        $(".search_in_page").css("width", width);
      } else {
        $(".search_in_page").hide();
      }
      /* if (win_scroll_top >= (doc_height - win_height) * 0.99) {
        if (!this.processing && this.canLoadMore) {
          this.pageActive += 1;
          //this.getEmployeeList('List');
          console.log('last');
        }
        if(this.processing && this.canLoadMore){
          console.log('not last');
        }
       }*/
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    deleteItem(data) {
      this.delete_dialog_data.status = true;
      let message =
        "<p>" +
        this.$t("question.delete") +
        " " +
        data.firstName +
        " " +
        data.lastName +
        "?</p>";
      this.delete_dialog_data.message = message;
      this.delete_dialog_data.roworder = data.roworder;
    },
    onDelete() {
      DocumentService.deleteIncomeandExpenses(this.delete_dialog_data.roworder)
        .then((res) => {
          this.showSnackBar(this.$t("message.delete"), "success");
          this.pageActive = 1;
          this.table_data = [];
          this.getExpensesList();
          this.delete_dialog_data.status = false;
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        });
    },
    getExpensesList(Action) {
      this.commitSetShowLoading(true);
      console.log(this.SelectBranch)
       console.log(this.SelectDepartment)
      
      DocumentService.getIncomeandExpensesList(
        this.SelectBranch,
        this.SelectDepartment,
        this.SelectPosition,
        this.Search_data,
        this.pageActive,
        this.FromDate,
        this.ToDate
      )
        .then((res) => {
          this.table_data = [];
          if (this.table_data.length > 0 && Action == "List") {
            if (res.data.content.length > 0) {
              res.data.content.forEach((data) => {
                this.table_data.push(data);
              });
              this.totalPages = res.data.totalPages;
            } else {
              this.canLoadMore = false;
            }
          } else {
            res.data.content.forEach((data) => {
              if (data.trans_flag == 0) {
                this.table_data.push(data);
              }
            });
            // this.table_data = res.data.content;
            this.totalPages = res.data.totalPages;
          }
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
  },
};
</script>
<style>
.coco-label-icon {
  padding-bottom: 4px !important;
}
.setbox {
  padding: 0px !important;
  text-align: left;
  width: 100px;
}
.background {
  background: url("../../assets/banner1.png") no-repeat fixed top;
}
</style>
